<script setup>
import { computed } from '@vue/reactivity'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  displayArea: {
    type: String,
    required: true
  },
  kind: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  content: {
    type: String,
    default: ''
  },
  url: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  },
  img: {
    type: String,
    default: ''
  },
  icons: {
    type: Array,
    default: () => []
  }
})

const kindText = computed(() => {
  switch (props.kind) {
  case 'text':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.onlyText')
  case 'image':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.onlyImage')
  case 'url':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.onlyUrl')
  case 'link':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.textLink')
  case 'banner':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.banner')
  case 'icon':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.combination')
  case 'ad_type':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.shufoo')
  case 'movie_id':
    return t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.movieId')
  default:
    return ''
  }
})
</script>

<template>
  <div class="mapionBiz__item">
    <div class="mapionBiz__info">
      <p class="mapionBiz__name">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.name') }} ({{ props.displayArea }}) - {{ kindText }}：</p>
      <p class="mapionBiz__title">{{ props.title }}</p>
      <img v-if="img" class="mapionBiz__img" :src="props.img" alt="">
      <p class="mapionBiz__content">{{ props.content }}</p>
      <p class="mapionBiz__content">{{ props.url }}</p>
      <p v-if="props.alt" class="mapionBiz__content">
        <span class="fontBold">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.alt' ) }}</span>
        {{ props.alt }}
      </p>
      <div v-for="(icon, i) in props.icons" :key="i" class="mapionBiz__multiple">
        <img v-if="icon.image" class="mapionBiz__icon" :src="icon.image" alt="">
        <div class="mapionBiz__multiple__content">
          <div class="mapionBiz__content">
            {{ icon.name }}
          </div>
          <div class="mapionBiz__content">
            {{ icon.url }}
          </div>
          <div v-if="icon.alt" class="mapionBiz__content">
            <span class="fontBold">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.alt' ) }}</span>
            {{ icon.alt }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mapionBiz {
  &__item {
    display: flex;
    justify-content: space-between;
    padding: 0 32px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    margin-top: 16px;
  }
  &__info {
    padding: 24px 0;
  }
  &__name {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    margin-top: 16px;
  }
  &__title {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 16px;
  }
  &__content {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 5px;
  }
  &__multiple {
    display: flex;
    margin-bottom: 16px;
    &__content {
      margin: auto 0;
    }
  }
  &__img {
    width: calc(100% / 4);
    aspect-ratio: 1 / 1;
    object-fit: contain;
    border-radius: 4px;
  }
  &__icon {
    width: calc(100% / 10);
    aspect-ratio: 1 / 1;
    object-fit: contain;
    margin-right: 24px;
    border-radius: 4px;
  }
  .c-button {
    align-self: center;
    margin-top: 0;
    padding: 32px 0;
    &__item {
      margin: 0;
    }
  }
}
.fontBold {
  font-weight: bold;
}
</style>
